module.exports = __webpack_public_path__ + "img/wave.d525bb3c.svg";